import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { CampaignStatus } from 'src/app/models/campaign';
import { CampaignService } from 'src/app/services/campaign.service';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';

@Component({
    selector: 'app-campaign-relaunch-modal',
    templateUrl: './campaign-relaunch-modal.component.html',
    styleUrls: ['./campaign-relaunch-modal.component.scss']
})
export class CampaignRelaunchModalComponent implements OnInit {
    public step: number = 1;

    public campaignId: string;
    public status: CampaignStatus;
    public startDate: Date;
    public endDate: Date;
    public minStartDate: Date;
    public upcomingStatusDate: Date | null = null;
    public isAdmin: boolean = false;
    public today = new Date();
    dateFilter = (d: Date | null): boolean => {
        const date = d || new Date();
        return date >= this.today;
    };

    constructor(
        public dialog: MatDialog,
        private dialogRef: MatDialogRef<CampaignRelaunchModalComponent>,
        private campaignService: CampaignService,
        private authenticationService: AuthenticationService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.campaignId = data.campaignId;
        this.status = data.status;
        this.startDate = data.startDate;
        this.endDate = data.endDate;
        this.minStartDate = moment(this.today).add(2, 'd').toDate();
        this.isAdmin = this.authenticationService.isAdmin();

        // For admin with PAUSED campaigns - go directly to step 2 (confirmation)
        if (this.isAdmin && this.status === CampaignStatus.PAUSED) {
            this.step = 2;
        } else if (![CampaignStatus.LIVE, CampaignStatus.PARTIALLY_LIVE].includes(this.status)) {
            this.step = 0;
        }
    }

    ngOnInit(): void {}

    onUpcomingStatusDateChanged(date: Date | null): void {
        if (date) {
            this.upcomingStatusDate = date;
        }
    }

    isUpcomingDateWithinRange(): boolean {
        if (!this.upcomingStatusDate || !this.startDate || !this.endDate) {
            return false;
        }

        const upcoming = moment(this.upcomingStatusDate);
        const start = moment(this.today).add(1, 'd').toDate();
        const end = moment(this.endDate);

        const result = upcoming.isAfter(start) && upcoming.isSameOrBefore(end);
        return result;
    }

    moveSteps(nextStep) {
        this.step = nextStep;
    }

    getTitle() {
        if (this.isAdmin && this.status === CampaignStatus.PAUSED) {
            return 'Are you sure you want to relaunch this campaign?';
        }

        return 'Are you sure you want to relaunch this campaign?';
    }

    getDescription() {
        if (this.isAdmin && this.status === CampaignStatus.PAUSED) {
            return '';
        }

        return 'Your campaign will be relaunched on the specified date.';
    }

    canRelaunchCampaign(): boolean {
        if (this.isAdmin && this.status === CampaignStatus.PAUSED) {
            return true;
        }

        return this.isUpcomingDateWithinRange();
    }

    relaunchCampaign(): void {
        if (this.isAdmin && this.status === CampaignStatus.PAUSED) {
            this.campaignService.relaunchCampaign(this.campaignId).subscribe(_ => {
                this.dialogRef.close();
            });
        } else {
            this.campaignService
                .relaunchCampaign(this.campaignId, this.upcomingStatusDate)
                .subscribe(_ => {
                    this.dialogRef.close();
                });
        }
    }
}
